import { SCHEDULE } from "../../Config/Constants/ScheduleConstant";
import { getUserSchedules } from "../Services/ScheduleService";

export const getUserSchedulesAction = () => ({
    type: SCHEDULE.GET_SCHEDULE,
    payload: getUserSchedules(),
});
